// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".register-form[data-v-b8c62e4c]{max-width:600px;width:600px}.option-text[data-v-b8c62e4c]{margin-left:8px}.non-active-font[data-v-b8c62e4c]{color:#ccc}.non-active[data-v-b8c62e4c]{cursor:not-allowed;color:#ccc;background-color:#e4e4e4!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
